export type AppTabSpaceKey =
  | "home"
  | "rooms"
  | "activity"
  | "analytics"
  | "leaderboard"
  | "members"
  | "settings";

export type AppTabRoomKey = "home" | "settings";

export type AppTabUserKey =
  | "dashboard"
  | "create"
  | "profile"
  | "notifications"
  | "settings";

export type AppTabModel = "room" | "space" | "user";
